import api from 'apis/config/files-api';

interface UploadParams {
  [key: string]: any;
}

export const uploadFileApi = (
  file: File | FormData,
  url?: string,
  token?: string,
  params?: UploadParams,
  authorization?: string
) => {
  return api.post(`${url ? url : !token ? `files/upload/public` : `files?access_token=${token}`}`, file, {
    params,
    headers: {
      'Content-Type': 'multipart/form-data',
      Authorization: authorization ? `Bearer ${authorization}` : '',
    },
  });
};
